import {
  Package,
  Star,
  MessageCircle,
  RotateCcw,
  Ticket,
  Eye,
  Store,
  Crown,
  Gift,
  CircleUserRound,
  MapPin,
  CreditCard,
  CircleHelp,
  LogOut,
  HelpCircle,
  Truck,
  Box,
  Percent,
  Clock,
  Tag,
  Shield,
  ShieldCheck,
  Phone,
  Heart,
  ShoppingCart,
  LucideIcon,
} from "lucide-react";

const ICON_MAP: Record<string, LucideIcon> = {
  package: Package,
  star: Star,
  "message-circle": MessageCircle,
  "rotate-ccw": RotateCcw,
  ticket: Ticket,
  eye: Eye,
  store: Store,
  crown: Crown,
  gift: Gift,
  "circle-user": CircleUserRound,
  "map-pin": MapPin,
  "credit-card": CreditCard,
  "circle-question-mark": CircleHelp,
  "help-circle": HelpCircle,
  "log-out": LogOut,
  truck: Truck,
  box: Box,
  percent: Percent,
  clock: Clock,
  tag: Tag,
  shield: Shield,
  "shield-check": ShieldCheck,
  phone: Phone,
  heart: Heart,
  "shopping-cart": ShoppingCart,
};

export const getIcon = (
  iconName?: string,
  fallback: LucideIcon = Tag,
): LucideIcon => {
  if (!iconName) return fallback;
  return ICON_MAP[iconName.toLowerCase()] || fallback;
};
